export default {
    "en": {
        "All_Footer_Title1": "Try TODO MATH",
        "All_Footer_Title1_Description1_Description1": "Builds confidence and instills a love for math in ALL children.",
        "All_Footer_Copyright": "All Rights Reserved.",
        "All_Footer_Menubutton_Buttonname1": "Terms of Service",
        "All_Footer_Menubutton_Buttonname2": "Privacy",
        "All_Footer_Menubutton_Buttonname3": "Legal",
        "All_Footer_Menubutton_Buttonname4": "Contact",
        "All_Footer_Menubutton_Buttonname5": "Help",
        "All_Footer_SNSbutton_Buttonname1": "Instagram",
        "All_Footer_SNSbutton_Buttonname2": "Facebook",
        "All_Footer_SNSbutton_Buttonname3": "Twitter",
        "All_Footer_SNSbutton_Buttonname4": "Blog",
        "En_Footer_Dropdownmenu_Language1": "English",
        "Kr_Footer_Dropdownmenu_Language2": "한국어",
        "Cn_Footer_Dropdownmenu_Language3": "中文",
        "Jp_Footer_Dropdownmenu_Language4": "日本語",
        "All_Footer_SNSbutton_Buttonname5": "Youtube",
        "All_Footer_Title2": "Android Download"
    },
    "ko": {
        "All_Footer_Title1": "토도수학을 사용해 보세요!",
        "All_Footer_Title1_Description1_Description1": "아이들 모두에게 수학에 대한 사랑과 자신감을 키워줍니다.",
        "All_Footer_Copyright": "All Rights Reserved.",
        "All_Footer_Menubutton_Buttonname1": "이용약관",
        "All_Footer_Menubutton_Buttonname2": "개인정보처리방침",
        "All_Footer_Menubutton_Buttonname3": "법적고지",
        "All_Footer_Menubutton_Buttonname4": "문의",
        "All_Footer_Menubutton_Buttonname5": "도움말",
        "All_Footer_SNSbutton_Buttonname1": "인스타그램",
        "All_Footer_SNSbutton_Buttonname2": "페이스북",
        "All_Footer_SNSbutton_Buttonname3": "트위터",
        "All_Footer_SNSbutton_Buttonname4": "블로그",
        "En_Footer_Dropdownmenu_Language1": "English",
        "Kr_Footer_Dropdownmenu_Language2": "한국어",
        "Cn_Footer_Dropdownmenu_Language3": "中文",
        "Jp_Footer_Dropdownmenu_Language4": "日本語",
        "All_Footer_SNSbutton_Buttonname5": "유튜브",
        "All_Footer_Title2": "Android Download"
    },
    "cn": {
        "All_Footer_Title1": "尝试都都数学",
        "All_Footer_Title1_Description1_Description1": "为所有孩子建立信心和对数学的热爱。",
        "All_Footer_Copyright": "版权所有",
        "All_Footer_Menubutton_Buttonname1": "服务期限",
        "All_Footer_Menubutton_Buttonname2": "隐私",
        "All_Footer_Menubutton_Buttonname3": "法律",
        "All_Footer_Menubutton_Buttonname4": "联系我们",
        "All_Footer_Menubutton_Buttonname5": "帮助",
        "All_Footer_SNSbutton_Buttonname1": "Instagram",
        "All_Footer_SNSbutton_Buttonname2": "Facebook",
        "All_Footer_SNSbutton_Buttonname3": "Twitter",
        "All_Footer_SNSbutton_Buttonname4": "Blog",
        "En_Footer_Dropdownmenu_Language1": "English",
        "Kr_Footer_Dropdownmenu_Language2": "한국어",
        "Cn_Footer_Dropdownmenu_Language3": "中文",
        "Jp_Footer_Dropdownmenu_Language4": "日本語",
        "All_Footer_SNSbutton_Buttonname5": "Youtube",
        "All_Footer_Title2": "Android Download"
    },
    "ja": {
        "All_Footer_Title1": "トドさんすうを使ってみよう！",
        "All_Footer_Title1_Description1_Description1": "すべての子どもたちに、算数に対する親しみを持たせ自信感を育てます。",
        "All_Footer_Copyright": "All Rights Reserved.",
        "All_Footer_Menubutton_Buttonname1": "利用規約",
        "All_Footer_Menubutton_Buttonname2": "プライバシーポリシー",
        "All_Footer_Menubutton_Buttonname3": "Legal関連情報",
        "All_Footer_Menubutton_Buttonname4": "お問い合わせ",
        "All_Footer_Menubutton_Buttonname5": "ヘルプ",
        "All_Footer_SNSbutton_Buttonname1": "Instagram",
        "All_Footer_SNSbutton_Buttonname2": "Facebook",
        "All_Footer_SNSbutton_Buttonname3": "Twitter",
        "All_Footer_SNSbutton_Buttonname4": "Blog",
        "En_Footer_Dropdownmenu_Language1": "English",
        "Kr_Footer_Dropdownmenu_Language2": "한국어",
        "Cn_Footer_Dropdownmenu_Language3": "中文",
        "Jp_Footer_Dropdownmenu_Language4": "日本語",
        "All_Footer_SNSbutton_Buttonname5": "Youtube",
        "All_Footer_Title2": "Android Download"
    }
}


// WEBPACK FOOTER //
// ./src/text/common/footer.js